import { useLocation, useNavigate } from 'react-router-dom';

import { useConversaDaNyta as useConversaDaNytaDoNucleo } from '@maestra/core/telas/nyta/useConversaDaNyta';

// A CONVERSA COM A NYTA: a regra (o acesso, a conversa nova de verdade, o fio com as ações, o limite,
// as leituras) mora no núcleo desde 31/10/2026, e o app usa a mesma (docs/PLANO-APP-NATIVO.md). A web
// entrega o `navigate`, o `?prompt=` da página (apagado do endereço depois de enviado) e a largura
// em que abrir um módulo fecha o painel flutuante.

export const useConversaDaNyta = (onde: 'pagina' | 'flutuante') => {
  const navigate = useNavigate();
  const location = useLocation();
  return useConversaDaNytaDoNucleo(onde, {
    ir: navigate,
    pedido: {
      texto: new URLSearchParams(location.search).get('prompt'),
      consumir: () => navigate(location.pathname, { replace: true }),
    },
    telaPequena: () => typeof window !== 'undefined' && window.innerWidth < 672,
  });
};

export type { EstadoDaAcao, AcaoNaConversa, ItemDaConversa } from '@maestra/core/telas/nyta/useConversaDaNyta';
export type DadosDaConversa = ReturnType<typeof useConversaDaNyta>;
